var App = App || {};

App.SiteHeader = (function ($) {
    "use strict";

    function Search() {
        const searchOffcanvas = $("#site-header-search-offcanvas");
        const searchTextField = searchOffcanvas.find("input[type='text'].form-control");

        searchOffcanvas.on("shown.bs.offcanvas", function () {
            searchTextField.focus();
        });
    }

    function PrimaryNavDesktop() {

        var hovering = false;
        var megaMenuSpeed = 300;

        var menu = $(".site-header-content .site-header-primary > nav > ul");
        var level1MenuItems = menu.children("li").children("a, button");
        var level2MenuItems = menu.find(".mega-menu-level-2").children("ul").children("li").children("a");
        var level3MenuItems = menu.find(".mega-menu-level-3").children("ul").children("li").children("a");

        menu.find(".mega-menu").each(function () {
            $(this).find("a").attr("tabindex", -2);
        });;

        /**********************************************************************************
         ENTIRE MENU END HOVER
        /*********************************************************************************/
        menu.on("mouseleave", function () {
            hovering = false;
            level1MenuItems.trigger("blur");
        }).on("keydown", function (e) {
            if (e.key === "Tab" || e.key === "Escape") {
                hovering = false;
                MmClose($(this).children("li").children("a, button"));
            }
        });


        /**********************************************************************************
         LEVEL ONE ITEM HOVER/FOCUS
        /*********************************************************************************/
        level1MenuItems.on("mouseenter", function () {
            const speed = hovering !== true ? megaMenuSpeed : 1;
            MmOpen($(this), speed);
            hovering = true;
        }).on("focus", function () {
            MmOpen($(this), 1);
            hovering = true;
        }).on("blur", function () {
            if (hovering === false) {
                MmClose($(this));
            }
        }).on("keydown", function (e) {
            if (e.key === "ArrowRight") {
                e.preventDefault();
                $(this).parent("li").next("li").children("a, button").trigger("focus");
            }
            else if (e.key === "ArrowLeft") {
                e.preventDefault();
                $(this).parent("li").prev("li").children("a, button").trigger("focus");
            }
            else if (e.key === "ArrowDown") {
                hovering = true;
                e.preventDefault();
                $(this).siblings(".mega-menu").find(".mega-menu-level-2").children("ul").children("li").first().children("a, button").focus();
            }
        });


        /**********************************************************************************
         LEVEL TWO ITEM HOVER AND FOCUS
        /*********************************************************************************/
        level2MenuItems.parent("li").on("mouseenter", function () {
            MmLevel3Close($(this).siblings("li").children("a, button"));
            MmLevel3Open($(this).children("a, button"));
        });
        level2MenuItems.on("focus", function () {
            MmLevel3Close($(this).parents("li").siblings("li").children("a, button"));
            MmLevel3Open($(this));
        }).on("keydown", function (e) {
            if (e.key === "ArrowRight") {
                e.preventDefault();
                $(this).siblings(".mega-menu-level-3").children("ul").children("li").first().children("a, button").trigger("focus");
            }
            else if (e.key === "ArrowDown") {
                e.preventDefault();
                $(this).parent("li").next("li").children("a, button").trigger("focus");
            }
            else if (e.key === "ArrowUp") {
                e.preventDefault();
                if ($(this).parent("li").is(":first-child")) {
                    $(this).parents(".mega-menu").siblings("a, button").trigger("focus");
                }
                else {
                    $(this).parent("li").prev("li").children("a, button").trigger("focus");
                }
            }
        });

        /**********************************************************************************
         LEVEL THREE ITEM ARROWS
        /*********************************************************************************/
        level3MenuItems.on("keydown", function (e) {
            if (e.key === "ArrowLeft") {
                e.preventDefault();
                $(this).parents(".mega-menu-level-3").siblings("a, button").trigger("focus");
            }
            else if (e.key === "ArrowDown") {
                e.preventDefault();
                $(this).parent("li").next("li").children("a, button").trigger("focus");
            }
            else if (e.key === "ArrowUp") {
                e.preventDefault();
                $(this).parent("li").prev("li").children("a, button").trigger("focus");
            }
        });

        function MmOpen(Trigger, Speed) {

            MmClose(Trigger.parents("li").siblings("li").children("a, button"));

            const Menu = Trigger.siblings(".mega-menu");

            if (Menu.length) {

                Trigger.attr("aria-expanded", "true");

                // need to add body classes to handle z-index of mega menu
                Trigger.parents(".site-header").addClass("engaged");

                // start mega menu animation

                Menu.stop().slideDown(Speed);

                // if mega menu is more-right aligned than right edge of container
                if ((Menu.offset().left + Menu.outerWidth()) > (Menu.parents(".container").offset().left + Menu.parents(".container").outerWidth())) {
                    Menu.addClass("mega-menu-right");
                }

                // if no third level menu is left open, open the first one
                const mmLevel3Triggers = Menu.find(".mega-menu-level-2 li.has-children").children("a, button");
                if (mmLevel3Triggers.toArray().filter(x => x.ariaExpanded == "true").length == 0) {
                    MmLevel3Open(mmLevel3Triggers.first());
                }
            }
        }

        function MmClose(Trigger) {
            Trigger.attr("aria-expanded", "false");
            const Menu = Trigger.siblings(".mega-menu");
            Menu.stop().hide().removeClass("mega-menu-right");

            if ($(".site-header").find("[aria-expanded='true']").length == 0) {
                $(".site-header").removeClass("engaged");
            }

        }

        function MmLevel3Open(Level2Item) {
            const level3Menu = Level2Item.siblings(".mega-menu-level-3");

            Level2Item.attr("aria-expanded", "true");
            level3Menu.show();

            const level3Height = Math.max(level3Menu.children("ul").outerHeight(), Level2Item.parents(".mega-menu-level-2").height());
            Level2Item.parents(".mega-menu-level-2").height(level3Height).parents(".mega-menu").height("auto");
        }

        function MmLevel3Close(Level2Item) {

            const level3Menu = Level2Item.siblings(".mega-menu-level-3");
            Level2Item.attr("aria-expanded", "false");
            level3Menu.hide();

            const level2Menu = Level2Item.parents(".mega-menu-level-2");
            level2Menu.removeAttr("style");
        }
    }

    function PrimaryNavMobile() {



    }

    return {
        Search: Search,
        PrimaryNavDesktop: PrimaryNavDesktop,
        PrimaryNavMobile: PrimaryNavMobile
    };

})(jQuery);

$(function () {
    App.SiteHeader.Search();
    App.SiteHeader.PrimaryNavDesktop();
    App.SiteHeader.PrimaryNavMobile();
});